import module from 'colaborador/module.js'
import template from './template.html'

export class ColaboradorPrestamosExternosEliminarConfirmarComponent {
  descuentoId
  error = false
  resultado = { exito: false }
  procesando = false
  onClose = undefined

  constructor(ColaboradorPrestamoExterno) {
    this.ColaboradorPrestamoExternoService = ColaboradorPrestamoExterno
  }

  eliminar() {
    if (this.procesando) return

    this.procesando = true

    this.ColaboradorPrestamoExternoService.delete(this.descuentoId)
      .then((response) => this.resultado.exito = true)
      .catch((response) => this.error = response.data)
      .finally(() => this.procesando = false)
  }

  cerrar() {
    this.onClose({ $event: this.resultado })
  }
}

module.component('colaboradorPrestamosExternosEliminarConfirmar', {
  controller: ColaboradorPrestamosExternosEliminarConfirmarComponent,
  template,
  bindings: {
    descuentoId: '<',
    onClose: '&',
  },
})


// WEBPACK FOOTER //
// ./src/colaborador/components/prestamosExternos/eliminar/confirmar/component.js